import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as RightTickSvg } from 'assets/rightTick.svg';

const RightTickIcon: React.FC<SvgIconProps> = (props) => {
  return <SvgIcon {...props} component={RightTickSvg} />;
};

export default RightTickIcon;
